import React from 'react'
import { useStyles } from './styles'
import onClickOutside from 'react-onclickoutside'

const SimpleDropdown = ({ isOpen, onRequestClose, paper, children }) => {
    SimpleDropdown.handleClickOutside = e => onRequestClose && onRequestClose(e)
    const classes = useStyles()

    return (
        isOpen && (
            <div className={classes.anchor}>
                {paper ? <div className={classes.dropdown}>{children}</div> : children}
            </div>
        )
    )
}

const clickOutsideConfig = {
    handleClickOutside: () => SimpleDropdown.handleClickOutside,
}

const withClickOutside = config => component => onClickOutside(component, config)

export default withClickOutside(clickOutsideConfig)(SimpleDropdown)
